import { IDonor } from './donor';

export interface IDonorResponse {
    data: {
        success: boolean;
        results: IDonor;
    }
}
